import { useState } from "react";

import {
    CreateExplanatoryNoteResponse,
    CreateExplanatoryNoteStatus,
} from "../../../../../Common/CandyApiClient/Types/ExplanatoryNote/CreateExplanatoryNoteResponse";
import { useAsyncEffect } from "../../../../../Common/UseAsyncEffect";

export function useNotePreviewUrl(explanatoryNote?: CreateExplanatoryNoteResponse) {
    const [notePreviewUrl, setNotePreviewUrl] = useState<string | undefined>(undefined);

    useAsyncEffect(async () => {
        if (!notePreviewUrl) {
            const newPreviewUrl = await generateNotePreviewUrlIfNoteCreated(explanatoryNote);
            setNotePreviewUrl(newPreviewUrl);
        }
    }, [explanatoryNote]);

    return notePreviewUrl;
}

async function generateNotePreviewUrlIfNoteCreated(
    explanatoryNote?: CreateExplanatoryNoteResponse
): Promise<string | undefined> {
    const explanatoryNoteCreated = explanatoryNote?.status === CreateExplanatoryNoteStatus.Success;
    if (explanatoryNoteCreated) {
        return await generateNotePreviewUrl(explanatoryNote.driveUri);
    }

    return undefined;
}

async function generateNotePreviewUrl(driveUri: string): Promise<string | undefined> {
    try {
        const notePreviewUrl = await tryConvertNoteDriveUriToObjectUrl(driveUri);
        return notePreviewUrl;
    } catch {
        return undefined;
    }
}

async function tryConvertNoteDriveUriToObjectUrl(driveUri: string): Promise<string> {
    const noteBlob = await getNoteBlobFromDriveUri(driveUri);
    const objectURL = URL.createObjectURL(noteBlob);
    return objectURL;
}

async function getNoteBlobFromDriveUri(driveUri: string): Promise<Blob> {
    const response = await fetch(driveUri, { credentials: "include" });
    return response.blob();
}
